/**
 * flatpickr 挂载/销毁的两个共用动作（**从两个 modal 里逐字提取**）。
 *
 * ⚠️ 背景: `LessonEditorModal` 与 `ConvertStudentModal` 各自抄了一份**逐字相同**的实现
 *   （抄的是踩过坑的版本 —— 节点换人 / 开关关掉 / modal 拆掉 三条路径都要销毁，
 *    否则 document.body 上会留孤儿 `.flatpickr-calendar`，它的 document 监听会一直活着）。
 *   ⇒ 抄两份 = 以后加一道闸只改一处。
 *
 * ⛔ 本文件**只放纯逻辑**（不碰 DOM、不 import 任何东西）。
 */

/**
 * 在途挂载结束后, 若目标节点变了 ⇒ 自动补挂一次
 *
 * @param {object} dp      组件上的 `this._dp`（含 mounting / wantEl / instance / el / failedEl）
 * @param {Function} ensureFn 重新挂载的回调（各组件自己的 `ensureDatePicker`）
 */
export function retryDatePickerIfNeeded(dp, ensureFn) {
  if (dp.mounting) return;
  const want = dp.wantEl;
  if (!want || !want.isConnected) return;
  if (dp.instance && dp.el === want) return;
  if (dp.failedEl === want) return;
  ensureFn();
}

/**
 * 销毁 flatpickr (modal 关闭 / 节点换人 / 开关关掉)
 *
 * @param {object} dp 组件上的 `this._dp`
 */
export function destroyDatePicker(dp) {
  dp.wantEl = null;
  if (dp.instance) {
    try {
      dp.instance.destroy();
    } catch (e) {/* noop */}
    dp.instance = null;
  }
  dp.el = null;
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/utils/DatePickerState', { retryDatePickerIfNeeded: retryDatePickerIfNeeded,destroyDatePicker: destroyDatePicker, });